import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// styles and images
import "../../project/Project.css";
import Download from "../../../assets/download.svg";
import BlackDislike from "../../../assets/black-dislike.png";
import BlackLike from "../../../assets/black-like.png";
import Open from "../../../assets/open.svg";

//gobal
import {
  accountDataStore,
  companyStore,
  // messageAndErrorStore,
  // userStore,
} from "../../../store/Store";

// components
import SearchBar from "../../../components/SearchBar";
import UpdateReceivedInvPopup from "./UpdateReceivedInvPopup";
import ErrorDisplay from "../../../components/ErrorDisplay";
import Loading from "../../../components/Loading";

// data
import {
  invoiceStatusFilterMap,
  vendorInvoiceStatusStyles,
} from "../../../data/collections-data";

// funcs
// import { GenerateReceivedDownload } from "../../../funcs/invoicing/GenerateDownload";
import CommentsPopup from "../CommentsPopup";

// hooks
import useGetFetch from "../../../hooks/useGetFetch";
import Dates from "../../../components/Dates";
import InvoiceStatusFilter from "../../../invoiceComponents/InvoiceStatusFilter";
import SelectFscMethodForDownload from "../../../invoiceComponents/SelectFscMethodForDownload";
import useDownloadProjectInvoice from "../../../hooks/useDownloadProjectInvoice";

export default function ReceivedInvoiceList() {
  // gobal
  const accountReceivedInvoices = accountDataStore(
    (data) => data.accountReceivedInvoices,
  );
  const setInvoiceCounts = companyStore((data) => data.setInvoiceCounts);
  const invoiceCounts = companyStore((data) => data.invoiceCounts);
  // const JwtToken = userStore((data) => data.JwtToken);
  // const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  const [trigger, setTrigger] = useState(false);
  const [triggerComments, setCommentsTrigger] = useState(false);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [displayInvoices, setDisplayInvoices] = useState([]);
  const [filter, setFilter] = useState("in_progress");
  const [inv, setInv] = useState(null);
  const [actionId, setActionId] = useState(null);
  const [adjustments, setAdjustments] = useState();
  const [fscMethodTrigger, setFscMethodTrigger] = useState(false);
  const [invoiceForDownload, setInvoiceForDownload] = useState();
  const [fscMethod, setFscMethod] = useState(0);
  const [downloadPending, setDownloadPending] = useState(false);
  const [projectId, setProjectId] = useState(0);

  const navigate = useNavigate();

  const { isPending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/lc/invoice-counts/0`,
    setInvoiceCounts,
  );

  const { isPending: adjustmentsPending, error: adjustmentsError } =
    useGetFetch(
      `${process.env.REACT_APP_BACKEND}/lc/invoice-adjustments/0?is_vendor=true&is_received=true`,
      setAdjustments,
    );
  // filter invoices
  useEffect(() => {
    var invoices;
    if (accountReceivedInvoices) {
      switch (filter) {
        case "in_progress":
          invoices = accountReceivedInvoices.filter(
            (x) => x.invoice_status_id === 32,
          );
          break;
        case "approved":
          invoices = accountReceivedInvoices.filter(
            (x) => x.invoice_status_id === 29,
          );
          break;
        case "paid":
          invoices = accountReceivedInvoices.filter(
            (x) => x.invoice_status_id === 31,
          );
          break;
        case "disputed":
          invoices = accountReceivedInvoices.filter(
            (x) => x.invoice_status_id === 30,
          );
          break;
        default:
          invoices = accountReceivedInvoices.filter(
            (x) => x.invoice_status_id === 32,
          );
      }
    }
    setFilteredInvoices(invoices);
    setDisplayInvoices(invoices);
  }, [filter, accountReceivedInvoices]);

  const intitiateDownload = (inv) => {
    if (inv.project_id) {
      setProjectId(inv.project_id);
    }
    if (inv.fsc_cost > 0) {
      setFscMethodTrigger(true);
      setInvoiceForDownload(inv);
    } else {
      setInvoiceForDownload(inv);
    }
  };
  
  useDownloadProjectInvoice(
    false,
    fscMethodTrigger,
    null,
    setDownloadPending,
    setFscMethodTrigger,
    fscMethod,
    invoiceForDownload,
    null,
    null,
    true,
    projectId,
  );

  // const handleDownload = (inv) => {
  //   const controller = new AbortController();
  //   const headers = new Headers();
  //   headers.append("Content-Type", "application/json");
  //   headers.append("Authorization", "Bearer " + JwtToken);
  //   const requestOptions = {
  //     method: "GET",
  //     headers,
  //     signal: controller.signal,
  //   };
  //   var projectId = 0
  //   if (inv.project_id) {
  //     projectId = inv.project_id
  //   }
  //   fetch(
  //     `${process.env.REACT_APP_BACKEND}/lc/account-invoice/${inv.id}?project_id=${projectId}`,
  //     requestOptions,
  //   )
  //     .then((res) => {
  //       if (!res.ok) {
  //         toggleNewMessage(`${res.statusText} Status: ${res.status}`);
  //         return Promise.resolve();
  //       } else {
  //         return res.json();
  //       }
  //     })
  //     .then((data) => {
  //       if (!data) {
  //         return;
  //       } else {
  //         GenerateReceivedDownload(
  //           inv,
  //           data.invoice_loads,
  //           data.adjustments,
  //           data.uninvoiced_loads,
  //           data.uninvoiced_total,
  //         );
  //         toggleNewMessage(null, "Downloading");
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       toggleNewMessage("Something went wrong");
  //     });
  //   return () => controller.abort();
  // };

  const getInvoiceAction = (inv) => {
    switch (inv.invoice_status_id) {
      case 32:
        if (!inv.customer_approval_required) {
          return (
            <>
              <img
                className="account-invoice-action"
                style={{ margin: "0 10px 0 0" }}
                src={BlackLike}
                alt="black-like"
                onClick={() => handleStatus(29, inv)}
              />{" "}
              <img
                className="account-invoice-action"
                src={BlackDislike}
                alt="black-dislike"
                onClick={() => handleStatus(30, inv)}
              />
            </>
          );
        } else {
          if (
            inv.customer_approval_status_id === 23 ||
            inv.customer_approval_status_id === 24
          ) {
            return (
              <>
                <img
                  className="account-invoice-action"
                  style={{ margin: "0 10px 0 0" }}
                  src={BlackLike}
                  alt="black-like"
                  onClick={() => handleStatus(29, inv)}
                />{" "}
                <img
                  className="account-invoice-action"
                  src={BlackDislike}
                  alt="black-dislike"
                  onClick={() => handleStatus(30, inv)}
                />
              </>
            );
          }
        }
        break;
      default:
        return <p></p>;
    }
  };
  const handleStatus = (action, inv) => {
    setInv(inv);
    setActionId(action);
    setTrigger(true);
  };

  const handleComments = (inv) => {
    setInv(inv);
    setCommentsTrigger(true);
  };

  const handleClick = (projectId, invId) => {
    navigate(`/account-invoices/received/${invId}/${projectId}`);
  };
  const getValues = (inv) => {
    const vals = {
      adjustment_total: 0,
      total_after_adjustment: 0,
    };
    var adj;
    if (adjustments) {
      adj = adjustments.filter(
        (x) => x.invoice_id === inv.id && x.project_id === inv.project_id,
      );
      if (adj.length > 0) {
        vals.adjustment_total = parseFloat(adj[0].total_adjustment);
        vals.total_after_adjustment =
          inv.freight_cost + inv.fsc_cost + vals.adjustment_total;
      } else {
        vals.total_after_adjustment = inv.freight_cost + inv.fsc_cost;
      }
    }
    return vals;
  };

  if (error || adjustmentsError) {
    return <ErrorDisplay message={"Could not get invoice counts"} code={500} />;
  } else if (isPending || adjustmentsPending) {
    return <Loading />;
  }
  if (!accountReceivedInvoices) {
    return <p className="no-docs-added">No Invoices Have Been Added</p>;
  } else {
    return (
      <div>
        <div className="d-flex justify-content-between">
          <InvoiceStatusFilter
            setFilter={setFilter}
            invoiceCounts={invoiceCounts.received_counts}
          />
          <SearchBar
            data={filteredInvoices}
            field={"invoice_name"}
            setData={setDisplayInvoices}
          />
        </div>
        {displayInvoices.length > 0 ? (
          <div className="load-display-list">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Customer</th>
                  <th>Type</th>
                  <th>Start</th>
                  <th>End</th>
                  {(filter === "approved" || filter === "paid") && (
                    <th>Approval Date</th>
                  )}
                  <th>Loads</th>
                  <th>Weight (tons)</th>
                  <th>Freight</th>
                  <th>FSC</th>
                  <th>Adjustment</th>
                  <th>Total</th>
                  <th>Duplicate Tickets</th>
                  <th>Missing Tickets</th>
                  <th>Locked Loads</th>
                  <th>Action</th>
                  <th>Client Approval</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                {displayInvoices.map((inv, idx) => (
                  <tr key={idx}>
                    <td
                      onClick={() => handleClick(inv.project_id, inv.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {inv.invoice_name}
                    </td>
                    <td>{inv.company_name}</td>
                    <td>{inv.is_asset ? "Asset" : "Sand"}</td>
                    <Dates d={inv.start_date} />
                    <Dates d={inv.end_date} />
                    {(filter === "approved" || filter === "paid") && (
                      <Dates d={inv.approval_date.Time} isApproval={true} />
                    )}
                    <td>{inv.total_loads}</td>
                    <td>
                      {parseFloat(inv.total_weight_tons).toLocaleString(
                        "en-US",
                        { maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {parseFloat(inv.freight_cost).toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td>
                      $
                      {parseFloat(inv.fsc_cost).toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td>
                      ${getValues(inv).adjustment_total.toLocaleString("en-US")}
                    </td>
                    <td>
                      $
                      {getValues(inv).total_after_adjustment.toLocaleString(
                        "en-US",
                        { maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>{inv.duplicate_ticket_count}</td>
                    <td>{inv.missing_ticket_count}</td>
                    <td>{inv.locked_loads}</td>
                    <td>
                      <div className="d-flex">
                        <div className="invoice-action-col">
                          {!downloadPending && (
                            <img
                              className="account-invoice-action"
                              src={Download}
                              alt="download"
                              onClick={() => intitiateDownload(inv)}
                            />
                          )}
                        </div>
                        <div className="col">{getInvoiceAction(inv)}</div>
                      </div>
                    </td>
                    <td className="status-column">
                      <div
                        className={
                          vendorInvoiceStatusStyles[
                            inv.customer_approval_status_id
                          ]
                        }
                      >
                        {inv.customer_approval_status_id === 23 ||
                        inv.customer_approval_status_id === 24
                          ? "Approved"
                          : inv.customer_approval_status_id === 21 ||
                              inv.customer_approval_status_id === 25
                            ? "Pending"
                            : inv.customer_approval_status_id === 22
                              ? "Disputed"
                              : inv.customer_approval_status_id === 0 && ""}
                      </div>
                    </td>
                    <td>
                      {inv.invoice_comments !== "" && (
                        <img
                          className="account-invoice-action"
                          src={Open}
                          alt="open"
                          onClick={() => handleComments(inv)}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-docs-added">{`No ${invoiceStatusFilterMap[filter]} Invoices Exist`}</p>
        )}
        {trigger && (
          <UpdateReceivedInvPopup
            inv={inv}
            actionId={actionId}
            setTrigger={setTrigger}
          />
        )}
        {triggerComments && (
          <CommentsPopup inv={inv} setTrigger={setCommentsTrigger} />
        )}
        {fscMethodTrigger && (
          <SelectFscMethodForDownload
            setFscMethodTrigger={setFscMethodTrigger}
            setFscMethod={setFscMethod}
          />
        )}
      </div>
    );
  }
}
